import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { authState, checkAuth } from './lib/auth'

const routes: RouteRecordRaw[] = [
  { path: '/', redirect: '/moderate' },
  { path: '/login', component: () => import('./views/Login.vue') },
  {
    path: '/moderate',
    component: () => import('./views/Moderate.vue'),
    meta: { requiresAuth: true },
  },
  { path: '/display', component: () => import('./views/Display.vue') },
  // Backward-compatible redirects for old /admin/* bookmarks.
  { path: '/admin', redirect: '/moderate' },
  { path: '/admin/login', redirect: '/login' },
  { path: '/admin/moderate', redirect: '/moderate' },
  { path: '/admin/display', redirect: '/display' },
  { path: '/:pathMatch(.*)*', component: () => import('./views/NotFound.vue') },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to) => {
  if (!to.meta.requiresAuth) return true
  if (authState.authenticated === null) await checkAuth()
  if (!authState.authenticated) return { path: '/login', query: { redirect: to.fullPath } }
  return true
})
